import { ReportStatus, FuelLevel, PatrolStatus, WorkShift, VehicleType, VehicleStatus } from 'src/app/interfaces';

// ============================================================================
// 🎯 MAPEAMENTOS DE STATUS
// ============================================================================

/**
 * Converte string de status para enum ReportStatus
 */
export function toStatus(status: string): ReportStatus | VehicleStatus {
    switch (status) {
        //relatório
        case 'Pendente':
            return ReportStatus.PENDING;
        case 'Em andamento':
            return ReportStatus.IN_PROGRESS;
        case 'Concluída':
            return ReportStatus.RESOLVED;
        case 'Cancelada':
            return ReportStatus.CANCELLED;
        //veículo
        case 'Ativo':
            return VehicleStatus.ACTIVE;
        case 'Em Manutenção':
            return VehicleStatus.MAINTENANCE;
        case 'Inativo':
            return VehicleStatus.INACTIVE;
        default:
            return ReportStatus.PENDING;
    }
}

/**
 * Converte enum ReportStatus para string
 */
export function fromReportStatus(status: ReportStatus): string {
    switch (status) {
        case ReportStatus.PENDING:
            return 'Pendente';
        case ReportStatus.IN_PROGRESS:
            return 'Em andamento';
        case ReportStatus.RESOLVED:
            return 'Concluída';
        case ReportStatus.CANCELLED:
            return 'Cancelada';
        default:
            return 'Pendente';
    }
}
/**
 * Converte enum ReportStatus para string
 */
export function fromPatrolStatus(status: PatrolStatus): string {
    switch (status) {
        case PatrolStatus.IDLE:
            return 'Pendente';
        case PatrolStatus.STARTED:
            return 'Em andamento';
        case PatrolStatus.PAUSED:
            return 'Pausada';
        case PatrolStatus.COMPLETED:
            return 'Concluída';
        case PatrolStatus.CANCELLED:
            return 'Cancelada';
        default:
            return 'Pendente';
    }
}

// ============================================================================
// 🎯 MAPEAMENTOS DE COMBUSTÍVEL
// ============================================================================

/**
 * Converte string de combustível para enum FuelLevel
 */
export function toFuel(fuel: string): FuelLevel {
    switch (fuel) {
        case '1':
            return FuelLevel.FULL;
        case '1/2':
            return FuelLevel.HALF;
        case '0':
            return FuelLevel.EMPTY;
        default:
            return FuelLevel.FULL;
    }
}

/**
 * Converte enum FuelLevel para string
 */
export function fromFuel(fuel: FuelLevel): string {
    switch (fuel) {
        case FuelLevel.FULL:
            return '1';
        case FuelLevel.HALF:
            return '1/2';
        case FuelLevel.EMPTY:
            return '0';
        default:
            return '1';
    }
}

// ============================================================================
// 🎯 OBJETOS DE MAPEAMENTO (para uso direto)
// ============================================================================

export const StatusMapper = {
    to: toStatus,
    from: fromReportStatus,
} as const;

export const FuelMapper = {
    to: toFuel,
    from: fromFuel,
} as const;

// ============================================================================
// 🎯 MAPEAMENTOS DE TURNO DE TRABALHO
// ============================================================================

/**
 * Converte string de turno para enum WorkShift
 */
export function toWorkShift(shift: string): WorkShift {
    switch (shift) {
        case 'Diurno':
        case 'Dia':
            return WorkShift.DAY;
        case 'Noturno':
        case 'Noite':
            return WorkShift.NIGHT;
        default:
            return WorkShift.DAY;
    }
}

/**
 * Converte enum WorkShift para string
 */
export function fromWorkShift(shift: WorkShift): string {
    switch (shift) {
        case WorkShift.DAY:
            return 'Diurno';
        case WorkShift.NIGHT:
            return 'Noturno';
        default:
            return 'Diurno';
    }
}

// ============================================================================
// 🎯 MAPEAMENTOS DE TIPO DE VEÍCULO
// ============================================================================

/**
 * Converte string de tipo de veículo para enum VehicleType
 */
export function toVehicleType(type: string): VehicleType {
    switch (type) {
        case 'Viatura':
            return VehicleType.CAR;
        case 'Moto':
            return VehicleType.MOTORCYCLE;
        default:
            return VehicleType.CAR;
    }
}

/**
 * Converte enum VehicleType para string
 */
export function fromVehicleType(type: VehicleType): string {
    switch (type) {
        case VehicleType.CAR:
            return 'Viatura';
        case VehicleType.MOTORCYCLE:
            return 'Moto';
        default:
            return 'Viatura';
    }
}

// ============================================================================
// 🎯 MAPEAMENTOS DE STATUS DE VEÍCULO
// ============================================================================

/**
 * Converte string de status de veículo para enum VehicleStatus
 */
export function toVehicleStatus(status: string): VehicleStatus {
    switch (status) {
        case 'Ativo':
            return VehicleStatus.ACTIVE;
        case 'Em Manutenção':
        case 'Manutenção':
            return VehicleStatus.MAINTENANCE;
        case 'Inativo':
            return VehicleStatus.INACTIVE;
        default:
            return VehicleStatus.ACTIVE;
    }
}

/**
 * Converte enum VehicleStatus para string
 */
export function fromVehicleStatus(status: VehicleStatus): string {
    switch (status) {
        case VehicleStatus.ACTIVE:
            return 'Ativo';
        case VehicleStatus.MAINTENANCE:
            return 'Em Manutenção';
        case VehicleStatus.INACTIVE:
            return 'Inativo';
        default:
            return 'Ativo';
    }
}

// ============================================================================
// 🎯 OBJETOS DE MAPEAMENTO (para uso direto)
// ============================================================================

export const WorkShiftMapper = {
    to: toWorkShift,
    from: fromWorkShift,
} as const;

export const VehicleTypeMapper = {
    to: toVehicleType,
    from: fromVehicleType,
} as const;

export const VehicleStatusMapper = {
    to: toVehicleStatus,
    from: fromVehicleStatus,
} as const;
